import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import momentumlogo from "../assets/images/Momentum Logo (2).png";
import { useAppLogout } from "../Common/useAppLogout";
import CommonValues from "../Common/utils";
import Loader from "../Common/Loader";

export default function Login() {
  const { loginWithRedirect, isAuthenticated, isLoading, getAccessTokenSilently, user, logout, handleRedirectCallback } = useAuth0();
  const navigate = useNavigate();
  const appLogout = useAppLogout();
  const [socialLoading, setSocialLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const hasProcessedAuth = useRef(false);

  useEffect(() => {
    const runAuthCallback = async () => {
      if (window.location.search.includes("code=") && window.location.search.includes("state=")) {
        console.log("Handling Auth0 redirect callback...");
        try {
          await handleRedirectCallback(); // <--- This is required
          window.history.replaceState({}, document.title, window.location.pathname);
          console.log("Callback handled, reloading user...");
        } catch (err) {
          console.error("Error handling redirect callback", err);
        }
      }
    };

    runAuthCallback();
  }, []);

  useEffect(() => {

    const handleAuth0Callback = async () => {
      console.log("handleAuth0Callback called:", {
        isAuthenticated,
        hasUser: !!user,
        socialLoading,
        hasProcessedAuth: hasProcessedAuth.current
      });

      // Only process if authenticated, has user, not already processing, and hasn't been processed
      if (isAuthenticated && user && !socialLoading && !hasProcessedAuth.current) {
        hasProcessedAuth.current = true;
        try {
          // Get the access token from Auth0
          console.log("Getting access token...");
          const accessToken = await getAccessTokenSilently({
            authorizationParams: {
              audience: 'https://insurancegig-production.us.auth0.com/api/v2/',
            },
          });

          localStorage.setItem("igtoken", accessToken);

          // Decode JWT payload to check audience and claims
          try {
            const tokenParts = accessToken.split('.');
            const payload = JSON.parse(atob(tokenParts[1]));
            console.log("JWT Token Payload:", {
              aud: payload.aud, // audience
              iss: payload.iss, // issuer
              sub: payload.sub, // subject (user ID)
              exp: payload.exp, // expiration
              scope: payload.scope, // scopes
              email: payload.email,
              email_verified: payload.email_verified
            });
            console.log("JWT Token Audiences (detailed):", payload.aud);
            console.log("Is audience an array?", Array.isArray(payload.aud));
            if (Array.isArray(payload.aud)) {
              payload.aud.forEach((aud: string, index: number) => {
                console.log(`Audience ${index}:`, aud);
              });
            }
          } catch (e) {
            console.error("Failed to decode JWT:", e);
          }

  
          if (user && typeof user.email === 'string' && user.email.includes("@momentumamp.com")) {
            navigate("/chat");
          } else {
            localStorage.clear();
            setErrorMessage("You are unauthorized. Please use a valid MomentumAMP account.");
            setSocialLoading(false);
            hasProcessedAuth.current = false;
            return;
          }
      
          // const config = {
          //   method: "post",
          //   url: `${process.env.REACT_APP_Alexandria_API}/api/alexandria/validateSocialLogin`,
          //   headers: {
          //     "Content-Type": "application/json",
          //     Authorization: `Bearer ${accessToken}`,
          //   },
          // };

          // console.log("Backend URL:", config.url);
          // const response = await axios(config);
          // console.log("Backend response:", response.data);

          // if (response.data.token) {
          //   // Store the application token and user data
          //   localStorage.setItem("SocialLogin", "true");
          //   CommonValues.SetValues(
          //     response.data.token,
          //     response.data.userName,
          //     response.data.userId,
          //     response.data.avatarName,
          //     response.data.firstName,
          //     response.data.lastName
          //   );

          //   // Store additional user data
          //   localStorage.setItem("userName", response.data.userName);
          //   localStorage.setItem("RoleId", response.data.roleId);
          //   localStorage.setItem("AvatarName", response.data.avatarName);
          //   localStorage.setItem("OrgName", response.data.orgName);
          //   localStorage.setItem("CompanyName", response.data.companyName);

          //   console.log("Authentication successful, navigating to dashboard");
          //   setSocialLoading(false);
          //   navigate("/dashboard");
          // } else {
          //   console.error("No token received from backend");
          //   setErrorMessage("Authentication failed. No token received from server.");
          //   setSocialLoading(false);
          //   hasProcessedAuth.current = false;
          // }
          navigate("/chat");
        } catch (error: any) {
          console.error("Auth0 authentication error:", error);
          console.error("Error details:", {
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            message: error.message,
            config: error.config
          });

          setSocialLoading(false);
          hasProcessedAuth.current = false;

          // If 401, let's check if the user exists in the database
          // if (error.response?.status === 401) {
          //   console.log("401 error - checking if user exists in database...");
          //   try {
          //     const userCheckConfig = {
          //       method: "post",
          //       url: `${process.env.REACT_APP_Alexandria_API}/api/alexandria/getUserByAuhtUserId`,
          //       headers: {
          //         "Content-Type": "application/json",
          //       },
          //       data: {
          //         user_id: user.sub // Auth0 user ID
          //       }
          //     };

          //     const userCheckResponse = await axios(userCheckConfig);
          //     console.log("User exists in database:", userCheckResponse.data);
          //     setErrorMessage("User found in database but token validation failed. Check audience configuration.");
          //   } catch (userError: any) {
          //     console.log("User check error:", userError.response?.status);
          //     if (userError.response?.status === 401) {
          //       setErrorMessage("Account not found. Please register first or contact support to add your account.");
          //     } else {
          //       setErrorMessage("Error checking user account. Please contact support.");
          //     }
          //   }
          // } else if (error.response?.status === 409) {
          //   setErrorMessage("Multiple accounts found. Please contact support.");
          // } else if (error.response?.status === 500) {
          //   setErrorMessage("Server error. Please try again later.");
          // } else if (!error.response) {
          //   setErrorMessage("Network error. Please check your connection and try again.");
          // } else {
          //   setErrorMessage(`Authentication failed: ${error.response?.status || 'Unknown error'}. Please check your Auth0 configuration.`);
          // }

          // Don't automatically logout on error - let user try again
          console.log("Error occurred, but not logging out automatically");
        }
      }
    };

    // Only run the callback logic if we're authenticated and haven't processed yet
    if (isAuthenticated && user && !hasProcessedAuth.current) {
      handleAuth0Callback();
    }
  }, [isAuthenticated, user, getAccessTokenSilently, navigate]);

  // Check if already authenticated on component mount
  useEffect(() => {
    const token = CommonValues.GetToken();
    console.log("Checking existing token:", !!token);
    if (token && !isAuthenticated) {
      // User has app token but not Auth0 session, navigate to dashboard
      console.log("Found existing token, navigating to dashboard");
      navigate("/chat");
    }
  }, [isAuthenticated, navigate]);

  const onLoginWithNowcerts = () => {
    console.log("Nowcerts login clicked");
    window.open(process.env.REACT_APP_Nowcerts_Url, "_self");
  };

  const onLoginWithAuth0 = () => {
    try {

      console.log("Auth0 login clicked");
      console.log("Auth0 Config Check:", {
        domain: process.env.REACT_APP_AUTH0_DOMAIN,
        clientId: process.env.REACT_APP_AUTH0_CLIENT_ID
      });

      // Reset states
      setErrorMessage("");
      hasProcessedAuth.current = false;
      setSocialLoading(false);

      // Force Google SSO login
      loginWithRedirect({
        authorizationParams: {
          connection: 'google-oauth2',
          redirect_uri: window.location.origin,
          scope: "openid profile email",
          audience: "https://insurancegig-production.us.auth0.com/api/v2/"
        }
      });
    } catch (error) {
      console.error("Auth0 login error:", error);
      setErrorMessage("Auth0 login is not configured. Please use Nowcerts login instead.");
    }
  };

  const handleRetryAuth = () => {
    console.log("Retry authentication clicked");
    setErrorMessage("");
    hasProcessedAuth.current = false;
    setSocialLoading(false);

    if (isAuthenticated) {
      // Try the authentication process again
      const handleAuth0Callback = async () => {
        if (!hasProcessedAuth.current) {
          hasProcessedAuth.current = true;
          setSocialLoading(true);

          try {
            const accessToken = await getAccessTokenSilently({
              authorizationParams: {
                audience: 'https://insurancegig-production.us.auth0.com/api/v2/',
              },
            });

            const config = {
              method: "post",
              url: `${process.env.REACT_APP_Alexandria_API}/api/alexandria/validateSocialLogin`,
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              },
            };

            const response = await axios(config);

            if (response.data.token) {
              localStorage.setItem("SocialLogin", "true");
              CommonValues.SetValues(
                response.data.token,
                response.data.userName,
                response.data.userId,
                response.data.avatarName,
                response.data.firstName,
                response.data.lastName
              );

              localStorage.setItem("userName", response.data.userName);
              localStorage.setItem("RoleId", response.data.roleId);
              localStorage.setItem("AvatarName", response.data.avatarName);
              localStorage.setItem("OrgName", response.data.orgName);
              localStorage.setItem("CompanyName", response.data.companyName);

              navigate("/chat");
            }
          } catch (error) {
            console.error("Retry authentication error:", error);
            setSocialLoading(false);
            hasProcessedAuth.current = false;
            setErrorMessage("Retry failed. Please try logging in again.");
          }
        }
      };

      handleAuth0Callback();
    } else {
      // Not authenticated, try login again
      onLoginWithAuth0();
    }
  };

  // Check if Auth0 is properly configured
  const isAuth0Configured = process.env.REACT_APP_AUTH0_DOMAIN && process.env.REACT_APP_AUTH0_CLIENT_ID;

  // Show loading state during Auth0 processing
  // if (isLoading || socialLoading) {
  //   return (
  //     <div className="d-flex vh-100 bg-light d-flex justify-content-center align-items-center">
  //       <div className="flex-grow-1">
  //         <div className="container-xl">
  //           <div className="row g-3 d-flex justify-content-center align-items-center">
  //             <div className="col-4">
  //               <div className="card shadow-sm border-0 show-cursor p-3">
  //                 <div className="card-body text-center">
  //                   <img src={momentumlogo} alt="Logo" height={48} />
  //                   <h3 className="mt-3">
  //                     {isLoading ? "Loading..." : "Authenticating..."}
  //                   </h3>
  //                   <div className="d-flex justify-content-center">
  //                     <Loader />
  //                   </div>
  //                   {socialLoading && (
  //                     <p className="mt-2 text-muted small">
  //                       Validating your account...
  //                     </p>
  //                   )}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="d-flex vh-100 bg-light d-flex justify-content-center align-items-center">
      <div className="flex-grow-1  ">
        <div className="container-xl ">
          <div className="row g-3 d-flex justify-content-center align-items-center ">
            <div className="col-4">
              <div className="card shadow-sm border-0 show-cursor p-3">
                <div className="card-body text-center">
                  <img src={momentumlogo} alt="Logo" height={48} />
                  <div className="d-grid gap-2 mt-4">
                    {/* <Button label="Continue with Nowcerts" className="alexandria-btn primary-btn" onClick={onLoginWithNowcerts} /> */}
                    {isAuth0Configured && (
                      <Button label="Continue with Google" className="alexandria-btn secondary-btn" onClick={onLoginWithAuth0} />
                    )}
                  </div>
                  {!isAuth0Configured && (
                    <div className="mt-2 text-muted small">
                      Auth0 not configured. Check your .env file.
                    </div>
                  )}
                  {errorMessage && (
                    <div className="mt-3">
                      <div className="text-danger small mb-2">
                        {errorMessage}
                      </div>
                      {isAuthenticated && (
                        <Button
                          label="Retry Authentication"
                          className="alexandria-btn secondary-btn"
                          size="small"
                          onClick={handleRetryAuth}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}